var map = {
	"./de.json": 410027,
	"./en.json": 605238,
	"./es.json": 145348,
	"./fr.json": 124958,
	"./it.json": 709060,
	"./ja.json": 803035,
	"./ko.json": 983357,
	"./pl.json": 820063,
	"./pt.json": 287067,
	"./ru.json": 967195,
	"./uk.json": 462937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 373719;